import { render, staticRenderFns } from "./DialogQuestionHistory.vue?vue&type=template&id=1b6bac66&scoped=true"
import script from "./DialogQuestionHistory.vue?vue&type=script&lang=js"
export * from "./DialogQuestionHistory.vue?vue&type=script&lang=js"
import style0 from "./DialogQuestionHistory.vue?vue&type=style&index=0&id=1b6bac66&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b6bac66",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Nevo.SimAdmin.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b6bac66')) {
      api.createRecord('1b6bac66', component.options)
    } else {
      api.reload('1b6bac66', component.options)
    }
    module.hot.accept("./DialogQuestionHistory.vue?vue&type=template&id=1b6bac66&scoped=true", function () {
      api.rerender('1b6bac66', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DialogQuestionHistory.vue"
export default component.exports